import evadeBundleWoman from './evadeBundleWoman.json';
import evadeBundleMan from './evadeBundleWoman.json';
import mockBundlerGroups from './bundlerGroups.json';

export { evadeBundleWoman, evadeBundleMan, mockBundlerGroups };
